import { c as _c } from "react-compiler-runtime";
import { useEffect } from 'react';
export function useEmbeddedCommentChangeHandlers(t0) {
  "use memo";

  const $ = _c(5);
  const {
    isCommentModeActive,
    prevIsCommentModeActive,
    toggleOpenPopover
  } = t0;
  let t1;
  let t2;
  if ($[0] !== isCommentModeActive || $[1] !== prevIsCommentModeActive || $[2] !== toggleOpenPopover) {
    t1 = () => {
      if (!isCommentModeActive && prevIsCommentModeActive) {
        toggleOpenPopover(false);
      }
    };
    t2 = [isCommentModeActive, prevIsCommentModeActive, toggleOpenPopover];
    $[0] = isCommentModeActive;
    $[1] = prevIsCommentModeActive;
    $[2] = toggleOpenPopover;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
}